class GraphQLQueries {
    static GRAPHQL_QUERY_FETCH_POST_PREVIEWS = `
    query GetPostPreviews($first: Int, $after: String) {
        posts(first: $first, after: $after) {
            nodes {
                id
                databaseId
                title
                slug
            }
        }
    }
    `;
    static GRAPHQL_QUERY_FETCH_SINGLE_POST = `
        query GetSinglePost($id: ID!) {
            post(id: $id, idType: ID) {
                id
                title
                date
                slug
                categories {
                    nodes {
                            name
                            slug
                    }
                }
                content(format: RENDERED)
                author {
                    node {
                        name
                    }
                }
            }
        }
    `;
    static GRAPHQL_QUERY_FETCH_POST_BY_SLUG = `
        query GetPostBySlug($slug: String!) {
            postBy(slug: $slug) {
                id
                title
                date
                slug
                categories {
                    nodes {
                            name
                            slug
                    }
                }
                content(format: RENDERED)
                author {
                    node {
                        name
                    }
                }
            }
        }
    `;
    static GRAPHQL_QUERY_FETCH_ALL_POSTS = `
		query GetAllPosts($first: Int, $after: String) {
			posts(first: $first, after: $after, where: {orderby: {field: DATE, order: DESC}}) {
				pageInfo {
					hasNextPage
					endCursor
				}
				nodes {
					id
					databaseId
					title
					date
					slug
					content(format: RENDERED)
					categories {
						nodes {
							name
							slug
						}
					}
					author {
						node {
							name
						}
					}
				}
			}
		}
	`;
}
export default GraphQLQueries;
